export default __webpack_public_path__ + "static/media/background.72d77a57.jpg";